const numberFormatter = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });
const currencyFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 2,
});

export const formatNumber = (value: number, digits = 1): string =>
  new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

export const formatCompactNumber = (value: number): string => numberFormatter.format(value);

export const formatCurrency = (value: number): string => currencyFormatter.format(value);

export const formatPercent = (value: number, digits = 1): string =>
  `${formatNumber(value, digits)}%`;

export const formatIstDateTime = (value: string | number | Date): string =>
  `${new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'Asia/Kolkata',
  }).format(new Date(value))} IST`;

export const isIndianMarketOpen = (value: Date = new Date()): boolean => {
  const parts = new Intl.DateTimeFormat('en-IN', {
    weekday: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'Asia/Kolkata',
  }).formatToParts(value);
  const weekday = parts.find((part) => part.type === 'weekday')?.value;
  const hour = Number(parts.find((part) => part.type === 'hour')?.value);
  const minute = Number(parts.find((part) => part.type === 'minute')?.value);
  const totalMinutes = hour * 60 + minute;

  return (
    weekday !== 'Sat' &&
    weekday !== 'Sun' &&
    totalMinutes >= 9 * 60 &&
    totalMinutes < 16 * 60 + 30
  );
};

export const formatIstNewsTime = (value: string | number): string =>
  `${new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Asia/Kolkata',
  }).format(new Date(value))} IST`;
